import { Link } from 'react-router-dom';
import { promotions } from '@/mocks/home';

export default function PromotionSection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20dark%20crimson%20and%20deep%20gold%20accents%2C%20luxurious%20subtle%20texture%2C%20sports%20themed%20geometric%20patterns%2C%20elegant%20dark%20atmosphere%20with%20warm%20highlights%2C%20premium%20feel%20with%20soft%20glowing%20elements&width=1920&height=800&seq=promo-kaiyuan-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/85 to-foreground-950/95"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-500/20 text-accent-300 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">
            专属福利
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            加入开元体育，享受多重专属福利
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-base">
            注册即享新人礼包，更多精彩活动等您参与
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {promotions.map((promo) => (
            <div
              key={promo.id}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 hover:bg-white/10 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500/20 mb-5">
                <i className={`${promo.icon} text-xl text-accent-400`}></i>
              </div>
              <h3 className="text-base font-bold text-white mb-2">{promo.title}</h3>
              <p className="text-sm text-white/60 leading-relaxed">{promo.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 hover:bg-accent-600 text-foreground-950 font-bold rounded-full text-base transition-all duration-300 whitespace-nowrap"
          >
            立即领取福利
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}